import React, { useEffect, useState } from 'react';

const About = () => {
  return (
    <>
      <section className='about-section'>
        {/* <div className="top-rotten-curve"></div>
                <div className="bottom-rotten-curve"></div> */}
        {/* <div className="circle-one"></div>
                <div className="circle-two"></div> */}

        <div className='auto-container'>
          <div className='row clearfix'>
            <div className='left-column col-lg-6 col-md-12 col-sm-12'>
              <div className='inner'>
                <div className='sec-title'>
                  <div className='sub-title'>
                    <strong>About Us</strong>
                  </div>
                  <h3>Sadqa-E-Jariya Welfare Foundation</h3>
                  <div className='text'>
                    <p>
                      Sadqa-E-Jariya Welfare Foundation has been established
                      with the goal to support the orphans (yateems) and widows
                      (bewas) of our community. Our beloved Prophet (saw) said
                      those who support the orphan (yateem) will be with me like
                      the 2 fingers together. Our focus is to provide financial
                      support to these individuals and help them become
                      established in society by promoting education and
                      training, to learn skills that can make them self
                      sufficient and transform them from the receivers to the
                      givers, so that they may support the less fortunate.
                      InshaAllah!
                    </p>
                    <strong>
                      Our core Islamic principle illustrated in the Gracious
                      Quran:
                    </strong>
                    <p>
                      "They feed with food--despite their own desire for it--
                      the indigent, and the orphan and the captive (saying): ‘We
                      feed you purely for the sake of God. We desire no reward
                      from you, nor thankfulness." - Surah al-Insan 8-9
                    </p>
                    {/* <p>
                                        Please make Dua that Allah give Barakah to this effort as that also becomes a source of sadaqa for you and your family. May Allah accept our efforts in sadqajariya campaign and guides us in the path to success in the hereafter... Ameen!
                                        </p> */}
                  </div>
                  <div className='link-box clearfix'>
                    <a href='/about' className='theme-btn btn-style-one'>
                      <span className='btn-title'>Read More</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className='image-column col-lg-6 col-md-12 col-sm-12'>
              <div className='inner'>
                <div
                  className='image wow fadeInLeft animated'
                  data-wow-delay='0ms'
                  style={{
                    visibility: 'visible',
                    animationDelay: '0ms',
                    animationName: 'fadeInLeft',
                  }}
                >
                  <img
                    className='lazy-image loaded'
                    style={{ borderRadius: 20 }}
                    src='assets/images/resource/image-spacer-for-validation.png'
                    data-src='assets/images/resource/Sadqa-E-Jariya-muslims-volunteers-unity.jpg'
                    alt=''
                  />
                  <p>
                    "Believe in Allah and His Messenger and spend out of that in
                    which He has made you successors. For those who have
                    believed among you and spent, there will be a great reward."
                    Quran [57:7]
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="right-column col-lg-6 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image wow fadeInLeft animated" data-wow-delay="0ms" 
                                style={{visibility:"visible", animationDelay:"0ms", animationName:"fadeInLeft"}}
                                >
                                    <img className="lazy-image loaded" src="../assets/images/resource/sadqajariya.com-main-about-us.jpg" data-src="../assets/images/resource/sadqajariya.com-main-about-us.jpg" alt="" data-was-processed="true" /></div>
                            </div>
                        </div> */}
          </div>
          <div className='row clearfix'>
            <div className='col-lg-12 col-md-12 col-sm-12'>
              <p style={{ textAlign: 'center' }}>
                <strong>
                  {' '}
                  *Note:
                  {/* 100% of donations given to sadqajariya will go to the needy. There is no administrative fee.  */}
                  We are zakat eligible and any sadaqa is welcome. We are a
                  501c3 non-profit organization and all donations are tax
                  deductible. We will maintain a complete account record
                  certified by a CPA on our website that will be accessible to
                  our registered members.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
